<template>
    <div class="page">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.go('Pacientes', JSON.stringify({'t': Math.random()}));" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Prontuário eletrônico</div>
                <div class="right">
                    <a style="opacity: 0" class="link panel-open" data-panel="left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z" fill="black"></path>
                            <path d="M14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1045 10.8954 22 12 22C13.1046 22 14 21.1045 14 20Z" fill="black"></path>
                            <path d="M14 4C14 2.89544 13.1046 2.00001 12 2.00001C10.8954 2.00001 10 2.89544 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>        
        <div class="page-content" v-if="detalhes">
            
            <avatar-cropper
                @submit="submitAvatar"
                @uploading="uploadAvatar"
                :labels="{ 'submit': 'Ok', 'cancel': 'Cancelar'}"
                :upload-handler="uploadAvatar"
                trigger="#avatar-imagem" />
            
                <div class="container-bg">
                <div class="container" style="">
                    <h2 class="mb-0 hidden-xs">
                        <i class="las la-id-card"></i>
                        Prontuário Eletrônico
                    </h2>

                    <div style="" class="mt-40 hidden-xl hidden-lg hidden-md"></div>

                    <div class="list media-list no-hairlines mt-10 mb-20">
                        <ul class="row ">
                            <li class="col-100 medium-50">
                                <div class="item-content">
                                    <div class="item-media">
                                        <a id="avatar-imagem">
                                            <img :src="detalhes.imagem" width="70">
                                            <i class="las la-camera"></i>
                                        </a>
                                    </div>
                                    <div class="item-inner">
                                        <div class="item-title-row">
                                            <div class="item-title">
                                                {{detalhes.nome}}
                                            </div>
                                        </div>
                                        <div class="item-subtitle">{{detalhes.idade}} anos</div>
                                        <div class="item-subtitle">Id: {{detalhes.id}}</div>
                                    </div>
                                </div>
                            </li>
                            <li class="col-100 medium-50">
                                <p style="font-size: 14px; margin-top: 15px">
                                    <i class="las la-history"></i> Atendimentos realizados: {{detalhes.atendimentosRealizados}}<br>
                                    <i class="las la-file"></i> Prescrições geradas: {{detalhes.prescricoesGeradas}}<br>
                                    <i class="las la-clock"></i> Cadastrado em: {{detalhes.datahora | formatDate}}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <div class="row mb-15">
                        <div class="col-100 hidden-xl hidden-lg hidden-md mb-5">
                            <h6 class="mt-0 mb-0">Ações disponíveis:</h6>
                        </div>
                        <div class="col-100 medium-33 mb-5">
                            <button v-on:click="openModalHistorico()" class="button button-outline button-rounded button-large color-green" type="button">
                                <i class="las la-plus"></i> 
                                Adicionar registro
                            </button>
                        </div>
                        <div class="col-100 medium-33 mb-5">
                            <button v-on:click="openModalHistorico('documento')" class="button button-outline button-rounded button-large color-blue" type="button">
                                <i class="las la-upload"></i>
                                Anexar documento
                            </button>
                        </div>
                        <div class="col-100 medium-33 mb-5">
                            <!-- <button v-on:click="openModalPrescricao()" class="button button-outline button-rounded button-large color-primary" type="button">
                                <i class="las la-file-alt"></i>
                                Nova prescrição 
                            </button> -->
                            <!-- <button v-bind:class="{'disabled': !$root.memed.loaded}" v-on:click="openMemed()" class="button button-outline button-rounded button-large color-primary" type="button"> -->
                            <button v-on:click="openMemed()" v-bind:class="{'disabled':$root.user.registroClasseTipo && $root.user.registroClasseValor && $root.user.registroClasseEstado && !$root.memed.loaded}" class="button button-outline button-rounded button-large color-primary" type="button">
                                <i v-if="$root.memed.loaded" class="las la-file-alt"></i>
                                <i v-if="!$root.memed.loaded" class="rotating las la-sync-alt"></i>
                                Nova prescrição 
                            </button>
                        </div>

                        <!-- <div class="col-100 mt-20">
                            <div class="list no-hairlines mt-0 mb-10 " style="max-width: 100% !important;">                                   
                                <ul class="row">                
                                    <li class="col-100">
                                        <label class="item-content">
                                            <div class="item-inner">
                                                <div class="item-title">Assinatura digital</div>
                                                <div class="item-after">
                                                    <button v-on:click="openModalAssinatura()" type="button" class="button button-fill button-small color-orange">
                                                        <i class="las la-cog"></i>
                                                        Configurar
                                                    </button>
                                                </div>
                                            </div>
                                        </label>
                                    </li>  
                                    <li class="col-100">
                                        <a class="item-link smart-select smart-select-init" v-on:click="openModalAssinatura()">
                                            <div class="item-content">
                                                <div class="item-inner">
                                                    <div class="item-title">Certificado ativo</div><div class="item-after">{{formPrescricao.certificadoNome ? formPrescricao.certificadoNome : 'Nenhum'}}</div>
                                                </div>
                                            </div>
                                        </a>
                                    </li>                                      
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>

            <div class="container mt-20">
                <div class="row">
                    <div class="col-100 hidden-xl hidden-lg hidden-md mb-5">
                        <h6 class="mt-0 mb-0">Menu:</h6>
                    </div>                    
                    <div class="col-100 hidden-xs hidden-sm mt-10">
                        <div class="subnavbar">
                            <div class="subnavbar-inner">
                                <div class="segmented segmented-strong">
                                    <button class="button button-small-md" v-on:click="setTab('historico')" v-bind:class="{'button-active': tab == 'historico'}">
                                        <i class="las la-history"></i>
                                        Histórico do paciente
                                    </button>
                                    <button class="button button-small-md" v-on:click="setTab('informacoes')" v-bind:class="{'button-active': tab == 'informacoes'}">
                                        <i class="las la-user-circle"></i>
                                        Informações pessoais
                                    </button>
                                    <button class="button button-small-md" v-on:click="setTab('prescricoes')" v-bind:class="{'button-active': tab == 'prescricoes'}">
                                        <i class="las la-file"></i>
                                        Prescrições geradas
                                    </button>
                                    <span class="segmented-highlight"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-100 hidden-sm hidden-md hidden-lg hidden-xl">
                        <div class="row">
                            <div class="col-100">
                                <button class="button button-medium" v-on:click="setTab('historico')" v-bind:class="{'button-active': tab == 'historico'}">
                                    <i class="las la-history"></i>
                                    Histórico do paciente
                                </button>                                
                            </div>
                            <div class="col-100">
                                <button class="button button-medium" v-on:click="setTab('informacoes')" v-bind:class="{'button-active': tab == 'informacoes'}">
                                    <i class="las la-user-circle"></i>
                                    Informações pessoais
                                </button>                            
                            </div>
                            <div class="col-100">
                                <button class="button button-medium" v-on:click="setTab('prescricoes')" v-bind:class="{'button-active': tab == 'prescricoes'}">
                                    <i class="las la-file"></i>
                                    Prescrições geradas
                                </button>
                            </div>                            
                        </div>
                    </div>
                    <div class="col-100" v-show="tab == 'historico'">

                        <div class="empty" v-if="Object.keys(registros.itens).length == 0 && registros.loaded" style="margin-top: 8%;"> 
                            <center>
                                <img src="static/images/empty.svg" style="width: 80%">
                                <p class="mt-0 pt-0">
                                    <i class="las la-times"></i>
                                    Nenhum resultado encontrado.
                                </p>
                            </center>
                        </div>
                        <div class="timeline" v-if="registros.loaded && Object.keys(registros.itens).length > 0">
                            <div class="timeline-item" v-for="(item, index) in registros.itens">
                                <div class="timeline-item-date"><small>{{index | formatDate}}</small>
                                </div>
                                <div class="timeline-item-divider"></div>
                                <div class="timeline-item-content">

                                    <div v-for="(item2, index2) in item" class="timeline-item-inner">
                                        <div class="timeline-item-time">{{item2.datahora.split(" ")[1]}}</div>
                                        <div v-if="item2.modelo" class="timeline-item-title">{{item2.modelo.nome}}</div>
                                        <div class="timeline-item-text">
                                            <div v-html="item2.conteudo"></div>
                                            <hr>

                                            <a :href="item3.url" target="_blank" class="link external" v-for="(item3, index3) in item2.arquivos" style="display: block;">
                                                <i class="las la-file"></i>
                                                <b>{{item3.name}}</b>
                                            </a>
                                            <a class="link external click" v-on:click="delRegistro(item2.cod)" style="display: block;">
                                                <i class="las la-trash"></i>
                                                Apagar
                                            </a>                                            
                                        
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>  
                        
                        <div class="block" style="text-align: center;" v-if="registros.pages.length > 1">
                    
                            <span style="display: inline-block; " v-show="registros.page > 1" v-on:click="formHistorico.page = (registros.page - 1); getHistorico(true);">
                                <div class="chip color-white">
                                    <div class="chip-label" style="color: #333 !important">
                                        <i class="las la-arrow-left"></i>
                                        Anterior
                                    </div>
                                </div>
                            </span>                    
                            
                            <span style="display: inline-block; " v-show="registros.page >= 1 && registros.page < (registros.pages.length)" v-on:click="formHistorico.page = (registros.page + 1); getHistorico(true);">
                                <div class="chip color-white">
                                    <div class="chip-label" style="color: #333 !important">
                                        Próxima
                                        <i class="las la-angle-right"></i>
                                    </div>
                                </div>
                            </span>   

                            <br>     

                            <span style="display: inline-block; margin-right: 5px; margin-top: 5px;" v-for="(item, index) in registros.pages" v-show="item.show">
                                <div class="chip " v-bind:class="{'color-primary': item.index == registros.page, 'color-gray': item.index != registros.page}" v-on:click="formHistorico.page = item.index; getHistorico();">
                                    <div class="chip-label">
                                        {{item.index}}
                                    </div>
                                </div>
                            </span>                                                             
                        
                        </div> 
                
                        
                    </div>
                    <div class="col-100" v-show="tab == 'informacoes'">
                        <form method="post" v-on:submit.prevent="submitEditar" novalidate="" autocomplete="off" class="row">
                            <div class="col-100" style="padding-left: 15px; padding-right: 15px;">
                                <h3>
                                    <i class="las la-user-circle"></i>
                                    Editar paciente
                                    <div class="mt-20 hidden-xl hidden-md hidden-lg"></div>
                                    <button type="submit" class=" button-medium color-green button button-fill mt-10 hidden-xs">
                                        <i class="las la-save"></i>
                                        Salvar paciente
                                    </button>
                                </h3>        
                            </div>           
                            <div class="col-100 hidden-xl hidden-sm hidden-md hidden-lg">                        
                                <button type="submit" class=" button-medium color-green button button-fill mt-0">
                                    <i class="las la-save"></i>
                                    Salvar paciente
                                </button>                                
                            </div>

                            <div class="col-100 list no-hairlines" style="margin-top: 16px">
                                <ul class="row">                                                                                    
                                    <li class="item-content item-input item-input-outline col-100 medium-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label" >Nome <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="formEditar.nome" placeholder="Escreva o nome" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>   
                                    <li class="item-content item-input item-input-outline col-100 medium-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">E-mail <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="email" v-model="formEditar.email" placeholder="Escreva o e-mail" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input item-input-outline col-80 medium-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Celular <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva o celular" autocomplete="new-password" v-model="formEditar.telefone" />
                                            </div>
                                        </div>
                                    </li>                                    
                                    <li class="item-content item-input item-input-outline col-80 medium-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">CPF <small>(opcional)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['###.###.###-##']" type="tel" class="form-control" autocomplete="new-password" v-model="formEditar.doc" placeholder="Informe o CPF" required />
                                            </div>
                                        </div>
                                    </li>     
                                    <li class="item-content item-input item-input-outline col-80 medium-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Data de nascimento <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap" style="max-width: 150px !important;">
                                                <the-mask :mask="['##/##/####']" :masked="true" type="tel" placeholder="Sua data de nascimento" value="" class="form-control" autocomplete="new-password" v-model="formEditar.dataNascimento"  required />
                                            </div>
                                        </div>
                                    </li>                                                                                                       
                                </ul>

                                <p style="padding-left: 12px">
                                    <i class="las la-map-marker"></i> 
                                    Endereço
                                </p>

                                <ul class="row">
                                    <li class="item-content item-input item-input-outline col-60 medium-40">
                                        <div class="item-inner">
                                            <div class="item-title item-label">CEP <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['#####-###']" :masked="true" type="tel" class="form-control" v-model="formEditar.cep" placeholder="_____-___" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input item-input-outline col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Rua <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="formEditar.endereco" placeholder="Escreva o endereço.." value="" class="form-control" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input item-input-outline col-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Número (opcional)</div>
                                            <div class="item-input-wrap">
                                                <input type="tel" v-model="formEditar.numero" placeholder="__" value="" class="form-control" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input item-input-outline col-100 medium-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Complemento <small>(opcional)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="formEditar.complemento" placeholder="" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>     
                                    <li class="item-content item-input item-input-outline col-100 medium-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Bairro <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="formEditar.bairro" placeholder="Escreva o bairro.." value="" class="form-control" />
                                            </div>
                                        </div>
                                    </li>            
                                    <li class="item-content item-input item-input-outline col-100 medium-50" >
                                        <div class="item-inner">
                                            <div class="item-title item-label">Cidade <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="formEditar.cidade" placeholder="Escreva a cidade.." value="" class="form-control" />
                                            </div>
                                        </div>
                                    </li>     
                                    <li class="item-content item-input item-input-outline col-100 medium-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Estado <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <select id="estado" class="form-control" readonly="" name="estado" required="" v-model="formEditar.estado" >
                                                    <option value="" disabled selected hidden>Estado</option>
                                                    <option value="AC">Acre</option>
                                                    <option value="AL">Alagoas</option>
                                                    <option value="AP">Amapá</option>
                                                    <option value="AM">Amazonas</option>
                                                    <option value="BA">Bahia</option>
                                                    <option value="CE">Ceará</option>
                                                    <option value="DF">Distrito Federal</option>
                                                    <option value="ES">Espírito Santo</option>
                                                    <option value="GO">Goiás</option>
                                                    <option value="MA">Maranhão</option>
                                                    <option value="MT">Mato Grosso</option>
                                                    <option value="MS">Mato Grosso do Sul</option>
                                                    <option value="MG">Minas Gerais</option>
                                                    <option value="PA">Pará</option>
                                                    <option value="PB">Paraíba</option>
                                                    <option value="PR">Paraná</option>
                                                    <option value="PE">Pernambuco</option>
                                                    <option value="PI">Piauí</option>
                                                    <option value="RJ">Rio de Janeiro</option>
                                                    <option value="RN">Rio Grande do Norte</option>
                                                    <option value="RS">Rio Grande do Sul</option>
                                                    <option value="RO">Rondônia</option>
                                                    <option value="RR">Roraima</option>
                                                    <option value="SC">Santa Catarina</option>
                                                    <option value="SP">São Paulo</option>
                                                    <option value="SE">Sergipe</option>
                                                    <option value="TO">Tocantins</option>
                                                </select>                                                  
                                            </div>
                                        </div>
                                    </li>  
                                </ul>                                  
                            </div>
                        </form>
                    </div>
                    <div class="col-100" v-show="tab == 'prescricoes'">

                        <div class="empty" v-if="Object.keys(prescricoes.itens).length == 0 && prescricoes.loaded" style="margin-top: 8%;"> 
                            <center>
                                <img src="static/images/empty.svg" style="width: 80%">
                                <p class="mt-0 pt-0">
                                    <i class="las la-times"></i>
                                    Nenhum resultado encontrado.
                                </p>
                            </center>
                        </div>
                        <div class="timeline" v-if="prescricoes.loaded && Object.keys(prescricoes.itens).length > 0">
                            <div class="timeline-item" v-for="(item, index) in prescricoes.itens">
                                <div class="timeline-item-date"><small>{{index | formatDate}}</small>
                                </div>
                                <div class="timeline-item-divider"></div>
                                <div class="timeline-item-content">

                                    <div v-for="(item2, index2) in item" class="timeline-item-inner">
                                        <div class="timeline-item-time">{{item2.datahora.split(" ")[1]}}</div>
                                        <div class="timeline-item-title">
                                            {{item2.modelo ? item2.modelo.nome : ''}}
                                            <!-- <span class="badge color-green" v-if="item2.arquivoAssinado">Assinatura digital</span> -->
                                        </div>
                                        <div class="timeline-item-text">
                                            <div v-html="item2.conteudo" class="v-html"></div>
                                            <hr>
<!-- 
                                            <a :href="item3.url" target="_blank" class="link external" v-for="(item3, index3) in item2.arquivos" style="display: block;">
                                                <i class="las la-file"></i>
                                                <b>{{item3.name}}</b>
                                            </a> -->
                                            <a class="link external click" v-if="!item2.arquivoAssinado" v-on:click="open(item2.arquivoLink)" style="display: block;">
                                                <i class="las la-file"></i>
                                                Visualizar / imprimir
                                            </a>
                                            <a class="link external click" v-if="!item2.arquivoAssinado && item2.arquivo" v-on:click="open($root.config.url + '/' + item2.arquivo)" style="display: block;">
                                                <i class="las la-file"></i>
                                                Visualizar / imprimir
                                            </a>
                                            <!-- <a class="link external click" v-if="!item2.arquivoAssinado" v-on:click="open($root.config.url + '/' + item2.arquivo)" style="display: block;">
                                                <i class="las la-file"></i>
                                                Visualizar / imprimir
                                            </a> -->
                                            <a class="link external click" v-if="item2.arquivoAssinado" v-on:click="open($root.config.url + '/' + item2.arquivoAssinado)" style="display: block;">
                                                <i class="las la-file"></i>
                                                Visualizar / imprimir
                                            </a>  
                                            <a class="link external click" v-on:click="sendWhatsApp(item2)" style="display: block;">
                                                <i class="lab la-whatsapp"></i>
                                                Enviar via WhatsApp
                                            </a>              
                                            <a class="link external click" v-on:click="sendEmail(item2)" style="display: block;">
                                                <i class="las la-envelope"></i>
                                                Enviar via e-mail
                                            </a>                                                                                                                                    
                                            <a class="link external click" v-on:click="delPrescricao(item2.cod)" style="display: block;">
                                                <i class="las la-trash"></i>
                                                Apagar
                                            </a>                                            
                                        
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>   


                        <div class="block" style="text-align: center;" v-if="prescricoes.pages.length > 1">
                    
                            <span style="display: inline-block; " v-show="prescricoes.page > 1" v-on:click="formPrescricao.page = (prescricoes.page - 1); getPrescricoes(true);">
                                <div class="chip color-white">
                                    <div class="chip-label" style="color: #333 !important">
                                        <i class="las la-arrow-left"></i>
                                        Anterior
                                    </div>
                                </div>
                            </span>                    
                            
                            <span style="display: inline-block; " v-show="prescricoes.page >= 1 && prescricoes.page < (prescricoes.pages.length)" v-on:click="formPrescricao.page = (prescricoes.page + 1); getPrescricoes(true);">
                                <div class="chip color-white">
                                    <div class="chip-label" style="color: #333 !important">
                                        Próxima
                                        <i class="las la-angle-right"></i>
                                    </div>
                                </div>
                            </span>   

                            <br>     

                            <span style="display: inline-block; margin-right: 5px; margin-top: 5px;" v-for="(item, index) in prescricoes.pages" v-show="item.show">
                                <div class="chip " v-bind:class="{'color-primary': item.index == prescricoes.page, 'color-gray': item.index != prescricoes.page}" v-on:click="formPrescricao.page = item.index; getPrescricoes();">
                                    <div class="chip-label">
                                        {{item.index}}
                                    </div>
                                </div>
                            </span>                                                             
                        
                        </div> 

                    </div>
                </div>
            </div>
        </div>
                

        <!-- modal de configurar assinatura digital -->
        <div class="tingle-modal modal-prontuario modal-assinatura modal-default tingle-modal--visible tingle-modal--overflow" style="" v-if="modalAssinatura">
            <div class="tingle-modal-box">
                <div class="tingle-modal-box__content">
                    <div class="row">
                        <div class="col-100" v-if="certificados.itens.length > 0">
                            <h3 style="">
                                <i class="las la-lock"></i>
                                Configuração do Certificado Digital
                            </h3>
                        </div>
                        <div class="col-100" v-if="certificados.itens.length > 0">
                            <p class="mt-0">
                                <i class="las la-info-circle"></i> Selecione abaixo o seu certificado digital ativo:
                            </p>                            
                            <div class="list list-strong-ios list-outline-ios list-dividers-ios mt-0 mb-20" style="max-width: 100% !important;">
                                <ul>
                                    <li v-for="(item, index) in certificados.itens" :key="item.cod">
                                        <label class="item-radio item-radio-icon-start item-content">
                                            <input type="radio" name="certificado" v-model="formPrescricao.certificadoCod" :value="item.cod">
                                            <i class="icon icon-radio"></i>
                                            <div class="item-inner">
                                                <div class="item-title">
                                                   #{{item.id}} - {{item.psc}} - {{item.docTipo}}: {{item.docNumero}}
                                                </div>
                                                <div class="item-after">
                                                    <small>Expira em {{item.expiraEm | formatDate}}</small>
                                                </div>
                                            </div>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-100">
                            <h3 style="">
                                <i class="las la-plus"></i>
                                Adicionar novo Certificado Digital
                            </h3>
                        </div>                        
                        <div class="col-100">
                            <p class="mt-0">
                                <i class="las la-info-circle"></i> Atenção: Você pode utilizar o token ou certificado em nuvem.
                            </p>
                            <form method="post" v-on:submit="submitAssinatura" onsubmit="return false;" novalidate="novalidate" autocomplete="off">
                                <div class="list no-hairlines mt-0 mb-10 " style="max-width: 100% !important;">
                                      
                                    <ul class="row">       
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Selecione o tipo do certificado</div>
                                                <div class="item-input-wrap">
                                                    <select id="psc" class="form-control" name="psc" required="" v-model="formAssinatura.psc" >
                                                        <option value="" disabled selected hidden>Selecione..</option>
                                                        <option value="CERTILLION_SIGNER">Certificado A1/A3 ou Token físico</option>
                                                        <option value="BIRDID">BIRDID</option>
                                                        <option value="VAULTID">VAULTID</option>
                                                        <option value="VIDAAS">VIDAAS</option>
                                                        <option value="NEOID">NEOID</option>
                                                        <option value="REMOTEID">REMOTEID</option>
                                                        <option value="SAFEID">SAFEID</option>
                                                    </select>                                                  
                                                </div>
                                                <small v-if="formAssinatura.psc == 'CERTILLION_SIGNER'" class="mt-10 mb-15">Caso seu certificado digital seja A3 (smartcard/token), deve-se instalar o <a style="text-decoration: underline; font-weight: bold;" v-on:click="open('http://download.certillion.com/')">'Assinador-Certillion'</a>. Caso seu certificado digital seja em NUVEM não há necessidade desta instalação.</small>
                                            </div>
                                        </li>    
                                        <li class="col-100" style="margin-top: -14px">
                                            <label class="item-content">
                                                <div class="item-inner">
                                                    <div class="item-title">Manter a assinatura ativa?</div>
                                                    <div class="item-after">
                                                        <div class="toggle toggle-init">
                                                          <input type="checkbox" v-model="formAssinatura.manterAtiva" value="1">
                                                          <span class="toggle-icon"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </label>
                                        </li> 
                                        <li class="item-content item-input col-100" v-if="formAssinatura.manterAtiva">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Selecione a duração da sessão</div>
                                                <div class="item-input-wrap">
                                                    <select id="duracao" class="form-control" name="duracao" required="" v-model="formAssinatura.duracao" >
                                                        <option value="" disabled selected hidden>Selecione..</option>
                                                        <option value="1">1 Hora</option>
                                                        <option value="2">2 Horas</option>
                                                        <option value="3">3 Horas</option>
                                                        <option value="4">4 Horas</option>
                                                        <option value="6">6 Horas</option>
                                                        <option value="8">8 Horas</option>
                                                        <option value="12">12 Horas</option>

                                                    </select>                                                  
                                                </div>
                                            </div>
                                        </li>                                                                                                                                                                    
                                    </ul>  
                                </div>  
                                <div class="row">
                                    <div class="col-100">
                                        <hr>
                                        <p>
                                            <small>
                                                Ao confirmar, você autoriza a aplicação a realizar assinatura com o seu certificado e ajustar o tempo de interação com o sistema.
                                            </small>
                                        </p>
                                    </div>
                                    <button type="button" v-on:click="closeModalAssinatura()" class=" button-large button button-fill color-red col-50 medium-50 mb-10">
                                        <i class="las la-times"></i> 
                                        Cancelar
                                    </button>                                           
                                    <button v-bind:class="{'disabled': !formAssinatura.psc || (formAssinatura.manterAtiva && !formAssinatura.duracao)}" type="submit" class=" button-large button button-fill color-green col-50 medium-50 mb-10">
                                        <i class="las la-check-circle"></i> 
                                        Prosseguir
                                    </button>                                                                             
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <a class="close" v-on:click="closeModalAssinatura()">
                <i class="las la-times"></i>
            </a>
        </div>



        <!-- modal de adicionar registro no historico do paciente -->
        <div class="tingle-modal modal-prontuario modal-default tingle-modal--visible tingle-modal--overflow" style="" v-if="modalHistorico">
            <div class="tingle-modal-box">
                <div class="tingle-modal-box__content">
                    <div class="row">
                        <div class="col-100">
                            <h3 style="">
                                <i class="las la-plus"></i>
                                Adicionar registro
                            </h3>
                        </div>
                        <div class="col-100">
                            <form method="post" v-on:submit="submitHistorico" onsubmit="return false;" novalidate="novalidate" autocomplete="off">
                                <div class="list no-hairlines mt-0 mb-10 " style="max-width: 100% !important;">
                                      
                                    <ul class="row">       
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Tipo</div>
                                                <div class="item-input-wrap">
                                                    <select id="tipo" class="form-control" name="tipo" required="" v-model="formHistorico.modeloCod" >
                                                        <option value="" disabled selected hidden>Selecione..</option>
                                                        <option v-for="(item, index) in modelos.itens" v-if="item.tipo == 'historico'" :key="item.cod" :value="item.cod">{{item.nome}}</option>
                                                    </select>                                                  
                                                </div>
                                            </div>
                                        </li>    
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Texto</div>
                                                <div class="item-input-wrap">
                                                                                                 
                                                    <div class="text-editor text-editor-init">
                                                        <div class="text-editor-content" @input="onInput('formHistorico', 'conteudo', $event)" contenteditable ></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>                                                                                                                
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Anexar arquivo(s) ({{formHistorico.arquivos.length}}/5)</div>
                                                <div class="item-input-wrap">                                                
                                                    <div class='file-input'>
                                                        <input type='file' multiple="" @change="getBase64('formHistorico', 'arquivos', $event)" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, image/*,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,video/*,audio/*">
                                                        <span class='button'>Escolher arquivo(s)</span>
                                                        <!-- <label class='label' v-show="formHistorico.arquivos.length == 0" data-js-label>Nenhum arquivo selecionado</label> -->
                                                    </div>
                                                    <p class="file-list" v-for="(item, index) in formHistorico.arquivos">
                                                        {{item.name}} <a class="float-right" v-on:click.stop.prevent="del(formHistorico.arquivos, item)"><i class="las la-times-circle"></i></a>
                                                    </p>
                                                </div>

                                            </div>
                                        </li>  
                                    </ul>  
                                </div>  
                                <div class="row">
                                    <button type="button" v-on:click="closeModalHistorico()" class=" button-large button button-fill color-red col-50 medium-33 mb-10">
                                        <i class="las la-times"></i> 
                                        Cancelar
                                    </button>   
                                    <button type="button" v-on:click="limparModalHistorico()" class=" button-large button button-fill color-gray col-50 medium-33 mb-10">
                                        <i class="las la-times"></i> 
                                        Limpar
                                    </button>                                            
                                    <button type="submit" class=" button-large button button-fill color-green col-100 medium-33 mb-10">
                                        <i class="las la-check-circle"></i> 
                                        Salvar registro
                                    </button>                                                                             
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <a class="close" v-on:click="closeModalHistorico()">
                <i class="las la-times"></i>
            </a>
        </div>

        <!-- modal de criar prescricoes -->
        <div class="tingle-modal modal-prontuario modal-default tingle-modal--visible tingle-modal--overflow" style="" v-if="modalPrescricao">
            <div class="tingle-modal-box">
                <div class="tingle-modal-box__content">
                    <div class="row">
                        <div class="col-100">
                            <h3 style="">
                                <i class="las la-plus"></i>
                                Nova prescrição eletrônica
                            </h3>
                        </div>
                        <div class="col-100">
                            <form method="post" v-on:submit="submitPrescricao" onsubmit="return false;" novalidate="novalidate" autocomplete="off">
                                <div class="list no-hairlines mt-0 mb-10 " style="max-width: 100% !important;">                                   
                                    <ul class="row">       
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Tipo</div>
                                                <div class="item-input-wrap">
                                                    <select id="tipo" class="form-control" name="tipo" required="" v-model="formPrescricao.modeloCod" >
                                                        <option value="" disabled selected hidden>Selecione..</option>
                                                        <option v-for="(item, index) in modelos.itens" v-if="item.tipo == 'prescricao'" :key="item.cod" :value="item.cod">{{item.nome}}</option>
                                                    </select>                                                  
                                                </div>
                                            </div>
                                        </li>    
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Título da prescrição</div>
                                                <div class="item-input-wrap">
                                                    <div class="">
                                                        <input type="text" v-model="formPrescricao.titulo" placeholder="Escreva aqui.." value="" class="form-control" />
                                                    </div>
                                                </div>
                                            </div>
                                        </li>   
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Adicionar à prescrição</div>
                                                <div class="item-input-wrap">
                                                    <div class="">
                                                        <input type="text" id="autocomplete-dropdown" v-model="formBulario.pesquisa" placeholder="Escreva o medicamento aqui para pesquisar.." value="" class="form-control" />
                                                    </div>
                                                </div>
                                            </div>
                                        </li>                      
                                        <li class="item-content col-100 pt-30 pb-30" style="flex-direction: column">
                                            <div class="item-inner" style="width: 100%">
                                                <div class="item-title item-label">Itens da prescrição</div>
                                            </div>                                            
                                            <table>
                                                <tr v-for="(item, index) in formPrescricao.itens">
                                                    <td>
                                                        <a style="text-decoration: underline" onclick="alert('Em desenvolvimento')">{{ item.nome }}</a>
                                                        <small>{{item.subtitulo}}</small>
                                                        <input type="text" placeholder="Posologia" v-model="item.posologia" style="">
                                                    </td>
                                                    <td style="width: 30px">
                                                        <input type="number" value="1">
                                                    </td>
                                                    <td style="width: 110px">
                                                        <select>
                                                            <option>Embalagens</option>
                                                            <option>Frascos</option>
                                                            <option>Tubos</option>
                                                            <option>Cápsulas</option>
                                                            <option>Drágeas</option>
                                                            <option>Comprimidos</option>
                                                            <option>Sachês</option>
                                                            <option>Uso contínuo</option>
                                                        </select>
                                                    </td>
                                                    <td style="width: 50px; text-align: center;">
                                                        <a class="delete">
                                                            <i class="las la-trash-alt"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </table>
                                            <!-- <div class="item-inner"> -->
                                                
                                            <!-- </div> -->
                                        </li>
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Conteúdo</div>
                                                <div class="item-input-wrap">
                                                                                                 
                                                    <div class="text-editor text-editor-init form-prescricao-conteudo">
                                                        <div class="text-editor-content" @input="onInput('formPrescricao', 'conteudo', $event)" contenteditable></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>               
                                        <li class="col-100">
                                            <label class="item-content">
                                                <div class="item-inner">
                                                    <div class="item-title">Assinatura digital</div>
                                                    <div class="item-after">
                                                        <div class="toggle toggle-init">
                                                          <input type="checkbox" v-model="formPrescricao.assinatura" value="1">
                                                          <span class="toggle-icon"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </label>
                                        </li>       
                                        <li class="col-100" v-show="formPrescricao.assinatura">
                                            <a class="item-link" v-on:click="escolherCertificado()">
                                                <div class="item-content">
                                                  <div class="item-inner">
                                                    <div class="item-title">Certificado ativo</div><div class="item-after">{{formPrescricao.certificadoNome ? formPrescricao.certificadoNome : 'Nenhum'}}</div>
                                                  </div>
                                                </div>
                                            </a>
                                        </li>  
                                        <li class="item-content item-input col-100">
                                            <div class="hr"></div>
                                        </li>
                                        <li class="item-content item-input col-100 mb-10 mt-0">
                                            <h5 class="mb-0 mt-0">
                                                <i class="las la-cog"></i> 
                                                Configurações da prescrição
                                            </h5>
                                        </li>
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">CRM</div>
                                                <div class="item-input-wrap">
                                                    <div class="">
                                                        <input type="text" v-model="formPrescricao.pdfRegistroClasse" placeholder="Ex: 12345 SC" class="form-control" />
                                                        <small class="text-color-red">Confira seu número do CRM, ele será mostrado no cabeçalho da prescrição gerada.</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>  
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Especialidade</div>
                                                <div class="item-input-wrap">
                                                    <div class="">
                                                        <input type="text" v-model="formPrescricao.pdfEspecialidade" placeholder="Ex: Clínico Geral" class="form-control" />
                                                        <small class="text-color-red">Especialidade que será mostrada no cabeçalho da prescrição gerada.</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>  
                                        <li class="col-100">
                                            <a>
                                                <div class="item-content">
                                                  <div class="item-inner">
                                                    <div class="item-title" style="white-space: normal;">
                                                        Logomarca
                                                        <small style="font-weight: 400;" class="text-color-red">Envie uma logomarca para aparecer no cabeçalho do PDF da prescrição gerada.</small>
                                                    </div>
                                                    <div class="item-after">
                                                    </div>
                                                  </div>
                                                </div>
                                            </a>
                                        </li>                                          
                                    </ul>
                                    <div class='file-input ml-15' style="padding-top: 0px">
                                        <input type='file' @change="getBase64Unico('formPrescricao', 'pdfLogo', $event)" accept="image/*">
                                        <span class='button'>Escolher imagem</span>
                                        <img v-if="formPrescricao.pdfLogo" :src="formPrescricao.pdfLogo" style="max-width: 150px; width: auto; max-height: 30px; height: auto; float: right">
                                    </div>                                        
                                </div>  
                                <div class="row mt-15" style="">
                                    <button type="button" v-on:click="closeModalPrescricao()" class=" button-large button button-fill color-red col-50 medium-33 mb-10">
                                        <i class="las la-times"></i> 
                                        Cancelar
                                    </button>   
                                    <button type="button" v-on:click="limparModalPrescricao()" class=" button-large button button-fill color-gray col-50 medium-33 mb-10">
                                        <i class="las la-times"></i> 
                                        Limpar
                                    </button>                                            
                                    <button type="submit" class=" button-large button button-fill color-green col-100 medium-33 mb-10">
                                        <i class="las la-check-circle"></i> 
                                        Gerar prescrição
                                    </button>                                          
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <a class="close" v-on:click="closeModalPrescricao()">
                <i class="las la-times"></i>
            </a>
        </div>        



        <!-- modal de completar dados para integração memed -->
        <div class="tingle-modal modal-prontuario modal-completar-dados modal-default tingle-modal--visible tingle-modal--overflow" style="" v-if="modalCompletarDados">
            <div class="tingle-modal-box">
                <div class="tingle-modal-box__content">
                    <div class="row">
                        <div class="col-100"></div>
                            <h3 style="">
                                <i class="las la-user"></i>
                                Complete seu cadastro para continuar
                            </h3>
                        </div>                    
                        <div class="col-100">
                            <p class="mt-0">
                                <i class="las la-info-circle"></i> Preencha abaixo as informações do seu registro de classe para poder criar prescrições.
                            </p>                            
                            <form method="post" v-on:submit="submitCompletarDados" onsubmit="return false;" novalidate="novalidate" autocomplete="off">
                                <div class="list no-hairlines mt-0 mb-10 " style="max-width: 100% !important;">
                                      
                                    <ul class="row">       
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Registro de classe</div>
                                                <div class="item-input-wrap">
                                                    <select id="registroClasseTipo" class="form-control" name="registroClasseTipo" required="" v-model="formCompletarDados.registroClasseTipo" >
                                                        <option value="" disabled selected hidden>Selecione..</option>
                                                        <option value="CRM">CRM</option>
                                                        <option value="CRO">CRO</option>
                                                        <option value="COREN">COREN</option>
                                                    </select>                                                  
                                                </div>
                                            </div>
                                        </li>    
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Número do registro</div>
                                                <div class="item-input-wrap">
                                                    <div class="">
                                                        <input type="tel" v-model="formCompletarDados.registroClasseValor" placeholder="Ex: 12345" class="form-control" />
                                                    </div>
                                                </div>
                                            </div>
                                        </li>                                         
                                        <li class="item-content item-input col-100">
                                            <div class="item-inner">
                                                <div class="item-title item-label">Estado do registro</div>
                                                <div class="item-input-wrap">
                                                    <div class="">
                                                        <select id="registroClasseEstado" class="form-control" name="registroClasseEstado" required="" v-model="formCompletarDados.registroClasseEstado" >
                                                            <option value="" disabled selected hidden>Estado</option>
                                                            <option value="AC">Acre</option>
                                                            <option value="AL">Alagoas</option>
                                                            <option value="AP">Amapá</option>
                                                            <option value="AM">Amazonas</option>
                                                            <option value="BA">Bahia</option>
                                                            <option value="CE">Ceará</option>
                                                            <option value="DF">Distrito Federal</option>
                                                            <option value="ES">Espírito Santo</option>
                                                            <option value="GO">Goiás</option>
                                                            <option value="MA">Maranhão</option>
                                                            <option value="MT">Mato Grosso</option>
                                                            <option value="MS">Mato Grosso do Sul</option>
                                                            <option value="MG">Minas Gerais</option>
                                                            <option value="PA">Pará</option>
                                                            <option value="PB">Paraíba</option>
                                                            <option value="PR">Paraná</option>
                                                            <option value="PE">Pernambuco</option>
                                                            <option value="PI">Piauí</option>
                                                            <option value="RJ">Rio de Janeiro</option>
                                                            <option value="RN">Rio Grande do Norte</option>
                                                            <option value="RS">Rio Grande do Sul</option>
                                                            <option value="RO">Rondônia</option>
                                                            <option value="RR">Roraima</option>
                                                            <option value="SC">Santa Catarina</option>
                                                            <option value="SP">São Paulo</option>
                                                            <option value="SE">Sergipe</option>
                                                            <option value="TO">Tocantins</option>
                                                        </select>                                                  
                                                    </div>
                                                </div>
                                            </div>
                                        </li>                                                                                                                                                                    
                                    </ul>  
                                </div>  
                                <div class="row">
                                    <div class="col-100">
                                        <hr>
                                        <p>
                                            <small>
                                                Ao confirmar, você autoriza a aplicação a realizar assinatura com o seu certificado e ajustar o tempo de interação com o sistema.
                                            </small>
                                        </p>
                                    </div>
                                    <button type="button" v-on:click="closeModalCompletarDados()" class=" button-large button button-fill color-red col-50 medium-50 mb-10">
                                        <i class="las la-times"></i> 
                                        Cancelar
                                    </button>                                           
                                    <button type="submit" class=" button-large button button-fill color-green col-50 medium-50 mb-10">
                                        <i class="las la-check-circle"></i> 
                                        Salvar dados
                                    </button>                                                                             
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <a class="close" v-on:click="closeModalAssinatura()">
                <i class="las la-times"></i>
            </a>
        </div>


    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'ProntuarioPacientes',
    components: {
        'AvatarCropper': AvatarCropper,
        'Toolbar': Toolbar,
        'Top': Top
    },          
    data () {
        var self                    = this;
        return {
            "tab":                  "historico",
            // "memed": {
            //     "loaded":           false
            // },
            "modalAssinatura":      false,
            "modalHistorico":       false,
            "modalPrescricao":      false,
            "modalCompletarDados":  false,
            "loading": {
                "submit":           false
            },   
            "modelos":              {
                "loaded":           false,
                "itens":            []
            },
            "certificados":         {
                "loaded":           false,
                "itens":            []
            },            
            "registros":            {
                "page":             1,
                "pages":            [],
                "total":            0,
                "loaded":           false,
                "itens":            []
            },
            "prescricoes":          {
                "page":             1,
                "pages":            [],
                "total":            0,
                "loaded":           false,
                "itens":            []
            },            
            "detalhes":             null,                      
            "formEditar": {

            },
            "formBulario": {
                "_cod":             "",
                "_token":           "",
                "pesquisa":        ""
            },
            "formPrescricao": {
                "_cod":             "",
                "_token":           "",
                "modeloCod":        "",
                "certificadoCod":   "",
                "itens": [
                ],
                "pdfLogo":          "",
                "conteudo":         ""
            },
            "formHistorico": {
                "_cod":             "",
                "_token":           "",
                "modeloCod":        "",
                "arquivos":         []
            },
            "formAssinatura": {
                "_cod":             "",
                "_token":           "",
                "psc":              "",
                "duracao":          ""
            },  
            "formCompletarDados": {
                "_cod":             "",
                "_token":           "",
                "acao": "completar",
                "registroClasseTipo":"",
                "registroClasseValor":"",
                "registroClasseEstado":""
            },                        
            "form": {
                "_cod":             "",
                "_token":           "",
                "modeloCod":        ""
            }            
        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1] || "";
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        }        
    },        
    watch: {
        "form.cep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        },
        "formPrescricao.certificadoCod": {
            handler: function(val) {
                var self = this;
                console.log("formPrescricao.certificadoCod > change>", val);
                var item = self.certificados.itens.filter(function(item) {
                    if (item.cod == val) return item;
                })[0];
                if (item) {
                    self.formPrescricao.certificadoNome = "#" + item.id + " - " + item.psc;
                }
                self.$forceUpdate();
            },
            deep: true
        },
        "formPrescricao.modeloCod": {
            handler: function(val) {
                var self = this;
                console.log("formPrescricao.modeloCod > change>", val);
                var item = self.modelos.itens.filter(function(item) {
                    if (item.cod == val) return item;
                })[0];
                if (item) {
                    self.formPrescricao.modelo = item;
                    self.formPrescricao.titulo = item.titulo;

                    item.texto = item.texto.replaceAll("{pacienteNome}", self.detalhes.nome);

                    // self.formPrescricao.conteudo = item.texto;
                    $(".form-prescricao-conteudo .text-editor-content").html(item.texto);
                    console.log("Definiu modelo", self.formPrescricao);
                }
                self.$forceUpdate();
            },
            deep: true
        },               
    },    
    methods: {
        sincronizarPrescricoesMemed: function() {
            var self            = this;
            return new Promise(function(resolve, reject) {

                console.log("sincronizarPrescricoesMemed()");
                loading.show();

                axios.put("api/prescricoes.php", {
                    "usuarioCod":   self.form.cod,
                    "acao":         "sincronizar-memed"
                }, {authentication: true})
                .then(response => {
                    
                    console.log("sincronizarPrescricoesMemed result", response.data.result)
                    loading.hide();
                    resolve(response.data);
                })
                .catch(error => {
                    loading.hide(); 
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        submitCompletarDados: function(e) {
            var self            = this;

            console.log("submitCompletarDados()", self.formCompletarDados);
            e.preventDefault();
            loading.show();

            self.formCompletarDados.usuarioCod = self.form.cod;

            axios.put("api/conta.php", self.formCompletarDados, {authentication: true})
            .then(response => {
                console.log("ok", response.data.result)

                loading.hide();
                alert(response.data.message);
                self.closeModalCompletarDados();
                self.limparModalCompletarDados();
                self.$root.setUser(response.data.result).then(function(result) {
                    self.initMemed();
                });

            })
            .catch(error => {
                loading.hide(); 
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },         
        openModalCompletarDados: function(tipo) {

            this.limparModalCompletarDados();
            this.modalCompletarDados = true;
            this.$forceUpdate();
        },
        limparModalCompletarDados: function() {
            // this.modalHistorico = false;
            this.formCompletarDados      = {
                "_cod":             "",
                "_token":           "",
                "acao": "completar",
                "registroClasseTipo":"",
                "registroClasseValor":"",
                "registroClasseEstado":""
            };
            this.$forceUpdate();
        },
        closeModalCompletarDados: function() {
            this.modalCompletarDados = false;
            this.$forceUpdate();
        },        
        initMemed: function() {
            var self        = this;
            console.log("initMemed()");
            // loading.show();
            return new Promise(function(resolve, reject) {


                if (!self.$root.user.memedToken) {
                    // console.log("nao possui token da memed, precisa cadastrar prescritor");
                    if (!self.$root.user.registroClasseTipo || !self.$root.user.registroClasseValor || !self.$root.user.registroClasseEstado) {
                        // depois de mostrar a popup, salvar os dados, dai chama o initMemed novamente
                        // self.openModalCompletarDados();
                        resolve(true);
                        return false;
                    }
                }
                // console.log("passou da validacao memed, memedToken:", self.$root.user.memedToken);

                if (!window.MdHub) {
                    var script              = document.createElement('script');
                    script.dataset.token    = self.$root.user.memedToken;
                    // script.src              = "https://integrations.memed.com.br/modulos/plataforma.sinapse-prescricao/build/sinapse-prescricao.min.js";
                    script.src              = "https://partners.memed.com.br/integration.js";
                    script.async            = false;
                    script.onload           = onload ? onload : function(e) {
                        console.log(e.target.src + ' is loaded.');

                        MdSinapsePrescricao.event.add("core:moduleInit", async function (module) {
                            // Verifica se o módulo 'plataforma.prescricao' está carregado
                            console.log("Memed moduleInit>", module);
                            if (module.name === "plataforma.prescricao") {
                                self.$root.memed.loaded = true;
                                self.$forceUpdate();
                                
                                resolve(true);
                                self.setWorkplace(self);

                                MdHub.event.add('prescricaoImpressa', function(prescriptionData) {
                                    console.log("prescricaoImpressa>", prescriptionData);
                                    // No objeto "prescriptionData", são retornadas as informações da prescrição gerada.
                                    // Implementar ações, callbacks, etc.
                                });
                                MdHub.event.add('prescricaoExcluida', function(prescriptionId) {
                                    console.log("prescricaoExcluida>", prescriptionId);
                                    self.delPrescricaoMemed(prescriptionId);
                                    // No objeto "prescriptionData", são retornadas as informações da prescrição gerada.
                                    // Implementar ações, callbacks, etc.
                                });                                

                            }                            
                        });

                        MdSinapsePrescricao.event.add("core:moduleHide", (module) => {
                            if (module.moduleName === "plataforma.prescricao") {
                                // significa que módulo plataforma-prescrição foi encerrado.
                                console.log("moduleHide prescricao>", module);
                                self.sincronizarPrescricoesMemed().finally(function() {
                                    self.setTab("prescricoes");
                                })
                                // fazer atualizar as prescricoes associadas ao ID do paciente
                            }
                        });                        

                    };                
                    document.head.appendChild(script);
                } else {
                    // self.$root.memed.loaded = true;
                    // self.$forceUpdate();
                                        
                }
            });   
        },     
        setWorkplace: async(self) => {
            let workplace = {
                city: self.$root.user.cidade,
                state: self.$root.user.estado,
                cnes: null,
                local_name: null,
                address: self.$root.user.endereco + ", " + self.$root.user.numero,
                phone: self.$root.user.telefone,
            };
            console.log("setWorkplace()", workplace);
            await MdHub.command.send("plataforma.prescricao", "setWorkplace", workplace);
        },
        openMemed: function() {
            var self = this;
            return new Promise(function(resolve, reject) {
                console.log("openMemed()");
                
                if (!self.$root.user.registroClasseTipo || !self.$root.user.registroClasseValor || !self.$root.user.registroClasseEstado) {
                    // depois de mostrar a popup, salvar os dados, dai chama o initMemed novamente
                    self.openModalCompletarDados();
                    return false;
                }                
                // console.log("passou openMemed")
                loading.show();

                var d           = self.detalhes.dataNascimento.split("-");
                let paciente    = {
                    idExterno:  self.detalhes.cod, // Obrigatório
                    nome:       self.detalhes.nome, // Obrigatório
                    telefone:   self.detalhes.telefone, // Obrigatório
                    cpf:        self.detalhes.doc, // Obrigatório caso o paciente não possua cpf, utilizar a tag withoutCpf: true
                    endereco:   self.detalhes.endereco + ", " + self.detalhes.numero, // Opcional
                    data_nascimento: self.detalhes.dataNascimento,
                    cidade:     self.detalhes.cidade
                };
                console.log("paciente:", paciente);
                
                MdHub.command.send("plataforma.prescricao", "setPaciente", paciente).then(function(result) {
                    
                    MdHub.command.send(
                        "plataforma.prescricao",
                        "setFeatureToggle",
                        {
                            guidesOnboarding: false
                        }
                    ).then(function(result) {
                        resolve(result);
                        console.log("setPaciente()", result)
                        MdHub.module.show("plataforma.prescricao");
                        setTimeout(function() {
                            loading.hide();
                        }, 1000);
                    });
                });
            });
        },     
        submitAvatar: function(e) {
            var self = this;
            console.log("submitAvatar()", e)
            // loading.show();
        },    
        uploadAvatar: function(e) {
            var self = this;
            console.log("uploadAvatar()", e)
            loading.show();
            e.getCroppedCanvas().toBlob((blob1) => {
                reduceFileSize(blob1, 500*1024, 800, Infinity, 0.6, blob2 => {
                    blobToBase64(blob2, function(result) {
                        // setTimeout(function() {
                        //     loading.hide();
                        // }, 500);
                        self.detalhes.imagem        = result;
                        self.formEditar.imagem      = result;
                        self.$forceUpdate();
                        self.submitEditar(false);
                    });
                });             
            });
            return true;
        },          
        open: function(link) {
            var self = this;
            console.log("open", link);
            window.open(link, "_system");
        },      
        escolherCertificado: function() {
            var self = this;

            var buttons = [];
            
            if (self.certificados.itens.length == 0) {

                window.___app.dialog.create({
                    on: {
                        closed: function (e) {
                            console.log("dialog closed", e);
                        }
                    },
                    title: 'Certificado',
                    text: "Você não possui nenhum certificado digital ativo.",
                    buttons: [
                        {
                            text: "Adicionar novo certificado",
                            onClick: function(e) {
                                self.modalPrescricao = false;
                                self.openModalAssinatura();
                            }
                        },
                        {
                            text: "Voltar",
                            onClick: function(e) {
                            }
                        }
                    ],
                    verticalButtons: true,
                }).open();                       
            } else {
                
                self.certificados.itens.forEach(function(item) {
                    buttons.unshift({
                        cssClass: "button-multiline",
                        text: "#"+ item.id + " - " + item.psc + " <br><small>" + item.docTipo + ": " + item.docNumero + "</small>",
                        onClick: function(e) {
                            console.log("onclick 1", e)
                            self.formPrescricao.certificadoCod = item.cod;
                            self.$forceUpdate();
                        }
                    });
                });

                buttons.push({
                    text: "Voltar",
                    onClick: function(e) {
                    }
                });            

                window.___app.dialog.create({
                    on: {
                        closed: function (e) {
                            console.log("dialog closed", e);
                        }
                    },
                    title: 'Escolha o certificado',
                    buttons: buttons,
                    verticalButtons: true,
                }).open();                  
            }          
        },
        del: function(itens, item) {
            console.log("del()", itens, item);
            var self = this;
            confirm("Você tem certeza que deseja remover este item?", function() {
                var index = itens.indexOf(item);
                itens.splice(index, 1);
                self.$forceUpdate();
            });
        },           
        getBase64: function(form, nome, event) {
            console.log("getBase64()", form, nome, event);
            var self            = this;
            if (event.target.files.length > 0) {
                loading.show();
                var files = [...event.target.files];
                self.$root.sequence(files, function(item) {
                    return new Promise(function(resolve, reject) {
                        if (self.formHistorico.arquivos.length >= 5) {
                            reject("Erro! Você só pode enviar até 5 arquivos.");
                        } else  {
                            getDataUrl(item, function(result) {
                            
                                console.log("getDataUrl() result", result);
                                self.formHistorico.arquivos.push({
                                    "name":     item.name,
                                    "type":     item.type,
                                    "url":      result
                                });
                                resolve(result);
        
                            }); 
                        }
                    }); 
                }).then(function(result) {

                    loading.hide();
                    console.log("getBase64() result", result);
                    self.$forceUpdate();

                }).catch(function(error) {
                    console.log("getBase64() error", error); 
                    loading.hide();
                    alert(error ? error : "Erro ao comprimir arquivos");
                });
            }      
        }, 
        getBase64Unico: function(form, nome, event) {
            console.log("getBase64()", form, nome, event);
            var self            = this;
            if (event.target.files.length > 0) {
                loading.show();
                getDataUrl(event.target.files[0], function(result) {
                
                    console.log("getDataUrl() result", result);
                    self[form][nome] = result;
                    self.$forceUpdate();
                    loading.hide();

                }); 
            }      
        },                        
        onInput: function(form, nome, event) {
            var self = this;
            console.log("onInput()", form, nome, event.target.innerHTML)
            self[form][nome] = event.target.innerHTML;
            self.$forceUpdate();
        },        
        setTab: function(tab) {
            var self = this;
            self.tab = tab;
            self.$forceUpdate();

            if (tab == "historico") {
                loading.show();
                self.getHistorico().finally(function() {
                    loading.hide();
                });
            } else if (tab == "prescricoes") {
                loading.show();
                self.getPrescricoes().finally(function() {
                    loading.hide();
                });
            }

        },
        atualizarCEP: function(val) {
            var self    = this;
            if (val) {
                if (val.length == 9) {
                    axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                    .then(response => {
                        if (response.data) {
                            if (response.data.logradouro) {
                                self.form.endereco  = response.data.logradouro;
                                self.form.bairro    = response.data.bairro;
                                self.form.cidade    = response.data.localidade;
                                self.form.estado    = response.data.uf;
                                self.$forceUpdate();
                            }
                        }
                    })
                    .catch(error => {
                    });
                }
            }
        },  
        openModalAssinatura: function() {
            this.modalAssinatura = true;
            this.formAssinatura.usuarioCod = this.form.cod;
            this.$forceUpdate();
        },
        openModalPrescricao: function() {
            var self = this;
            this.formPrescricao.modeloCod = "";
            this.formPrescricao.titulo = "";
            this.modalPrescricao = true;
            setTimeout(function() {
                self.initAutocompletePrescricao();
            }, 500);
            this.$forceUpdate();
            setTimeout(function() {
                window.___app.textEditor.create({
                    "el": $(".text-editor")[0]
                });                
            }, 1);
        },
        closeModalPrescricao: function() {
            this.modalPrescricao = false;
            this.$forceUpdate();
        },
        limparModalPrescricao: function() {
            // this.modalHistorico = false;
            this.formHistorico      = {
                "_cod":             "",
                "_token":           "",
                "modeloCod":        "",
                "conteudo":         ""
            };
            this.$forceUpdate();
        },
        closeModalAssinatura: function() {
            this.modalAssinatura = false;
            this.$forceUpdate();
        },                
        openModalHistorico: function(tipo) {

            this.limparModalHistorico();
            if (tipo) {
                var modelo = this.modelos.itens.filter(function(item) {
                    if (item.nome.toLowerCase().indexOf(tipo) !== -1) {
                        return item;
                    }
                })[0];
                console.log("achou modelo?", modelo);
                if (modelo) {
                    this.formHistorico.modeloCod = modelo.cod;
                }
            }
            this.modalHistorico = true;
            this.$forceUpdate();
            setTimeout(function() {
                window.___app.textEditor.create({
                    "el": $(".text-editor")[0]
                });                               
            }, 1);
        },
        limparModalHistorico: function() {
            // this.modalHistorico = false;
            this.formHistorico      = {
                "_cod":             "",
                "_token":           "",
                "modeloCod":        "",
                "arquivos":         []
            };
            this.$forceUpdate();
        },
        closeModalHistorico: function() {
            this.modalHistorico = false;
            this.$forceUpdate();
        },
        submitAssinatura: function(e) {
            var self            = this;

            console.log("submitAssinatura()", self.formAssinatura);
            e.preventDefault();
            loading.show();

            axios.post("api/assinatura.php", self.formAssinatura, {authentication: true})
            .then(response => {
                console.log("ok", response.data.result)

                self.closeModalAssinatura();

                if (response.data.result.url) {
                    location.href = response.data.result.url;
                } else {
                    loading.hide();
                }

            })
            .catch(error => {
                loading.hide(); 
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }, 
        submitHistorico: function(e) {
            var self            = this;

            console.log("submitHistorico()", self.formHistorico);
            e.preventDefault();
            loading.show();

            self.formHistorico.usuarioCod = self.form.cod;

            axios.post("api/prontuario.php", self.formHistorico, {authentication: true})
            .then(response => {
                console.log("ok", response.data.result)

                loading.hide();
                alert(response.data.message);
                self.closeModalHistorico();
                self.limparModalHistorico();
                self.setTab("historico");

            })
            .catch(error => {
                loading.hide(); 
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },  
        sendWhatsApp: function(obj) {
            var self    = this;
            var arquivo = obj.arquivoAssinado ? (self.$root.config.url + "/" + obj.arquivoAssinado) : (self.$root.config.url + "/" + obj.arquivo);

            window.___app.dialog.prompt(
                "Revise abaixo o número do WhatsApp do paciente antes de enviar", 
                '<i class="lab la-whatsapp"></i>  Enviar via WhatsApp', 
                function(result) {
                    console.log("result>", result);
                    var link = "https://api.whatsapp.com/send?phone=" + result + 
                                                                        "&text=Olá " + self.detalhes.nome + "%0a%0a" +
                                                                        "Visualize abaixo a sua prescrição digital: %0a%0a" + arquivo;
                    self.open(link);
                }, function(error) {
                    console.log("error>", error);
                }, "55" + self.detalhes.telefone
            );            
        },
        sendEmail: function(obj) {
            var self    = this;
            var arquivo = obj.arquivoAssinado ? (self.$root.config.url + "/" + obj.arquivoAssinado) : (self.$root.config.url + "/" + obj.arquivo);
            window.___app.dialog.prompt(
                "Revise abaixo o e-mail do paciente antes de enviar", 
                '<i class="las la-envelope"></i> Enviar via e-mail', 
                function(result) {
                    console.log("result>", result);
                    var link = " mailto:" + result + "?subject=" + obj.titulo + "&body=Olá " + self.detalhes.nome + "%0D%0A%0D%0A" +
                                                                        "Visualize abaixo a sua prescrição digital: %0D%0A%0D%0A" + arquivo;
                    self.open(link);
                }, function(error) {
                    console.log("error>", error);
                }, self.detalhes.email
            );               
        },        
        submitPrescricao: function(e) {
            var self            = this;

            console.log("submitPrescricao()", self.formPrescricao);
            e.preventDefault();
          
            loading.show();

            self.formPrescricao.usuarioCod = self.form.cod;

            axios.post("api/prescricoes.php", self.formPrescricao, {authentication: true})
            .then(response => {
                console.log("ok", response.data.result)

                loading.hide();
                // alert(response.data.message);
                self.closeModalPrescricao();
                self.limparModalPrescricao();
                self.setTab("prescricoes");

                var arquivo = response.data.result.arquivoAssinado ? (self.$root.config.url + "/" + response.data.result.arquivoAssinado) : (self.$root.config.url + "/" + response.data.result.arquivo);

                // mostrar alert com botoes
                window.___app.dialog.create({
                    title: response.data.message,
                    text: "",
                    buttons: [
                        {
                            text: '<i class="las la-file"></i> Visualizar / imprimir',
                            onClick: function(e) {
                                self.open(arquivo);
                            }
                        },
                        {
                            text: '<i class="lab la-whatsapp"></i> Enviar via WhatsApp',
                            onClick: function(e) {
                                self.sendWhatsApp(response.data.result);
                            }
                        },      
                        {
                            text: '<i class="las la-envelope"></i> Enviar via e-mail',
                            onClick: function(e) {
                                self.sendEmail(response.data.result);
                            }
                        },    
                        {
                            text: "Copiar link do documento",
                            onClick: function(e) {
                                copyTextToClipboard(arquivo);
                            }
                        },                                                                        
                        {
                            text: "Voltar",
                            onClick: function(e) {
                            }
                        }
                    ],
                    verticalButtons: true,
                }).open();                 


            })
            .catch(error => {
                loading.hide(); 
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },          
        submitEditar: function(e) {
            var self            = this;
            self.formEditar._cod      = self.$root.user.cod;
            self.formEditar._token    = self.$root.user.token;      

            console.log("submitEditar()", self.formEditar);
            if (e) e.preventDefault();
            loading.show();

            var request = function() {
                
                axios.put("api/pacientes-v2.php", self.formEditar, {authentication: true})
                .then(response => {
                    console.log("ok", response.data.result)

                    $(".page-content")[0].scrollTo({
                        top: 5
                    });                                             
                    loading.hide();
                    // self.$root.getUser();
                    if (e) alert(response.data.message);
                    // self.$root.back();

                })
                .catch(error => {
                    loading.hide(); 
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            }

            if (self.form.cep) {
                var geocoder                = new google.maps.Geocoder();
                var endereco                = self.form.endereco + ", " + self.form.numero + " - " + self.form.bairro + ", " + self.form.cidade + " - " + self.form.estado + ", " + self.form.cep;
                geocoder.geocode({ 'address': endereco}, function (results, status) {

                    console.log("Localizacao resultado >>", results)

                    if (results[0]) {

                        var latitude        = results[0].geometry.location.lat();
                        var longitude       = results[0].geometry.location.lng();
                        self.form.latitude  = latitude;
                        self.form.longitude = longitude;
                        console.log("Setou localizacao", self.form);
                        self.$forceUpdate();
                        request();
                    } else {
                        loading.hide();
                        alert("Erro! Informe um endereço válido e tente novamente por favor.");
                    }

                });     
            } else {
                request();
            }

        },
        getModelos: function() {
            var self        = this;
            console.log("getModelos()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "tipo":         "modelos"
                    },
                    "authentication":   true
                };

                axios.get("api/prontuario.php", form)
                .then(response => {
                    
                    console.log("getModelos() response", response);

                    self.modelos       = response.data.result; 
                    // loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);

                })
                .catch(error => {
                    console.log("getModelos() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },  
        getCertificados: function() {
            var self        = this;
            console.log("getCertificados()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "tipo":         "certificados"
                    },
                    "authentication":   true
                };

                axios.get("api/assinatura.php", form)
                .then(response => {
                    
                    console.log("getCertificados() response", response);

                    self.certificados   = response.data.result; 

                    if (!self.formPrescricao.certificadoCod && self.certificados.itens[0]) {
                        self.formPrescricao.certificadoCod = self.certificados.itens[0].cod;
                    }

                    // loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);

                })
                .catch(error => {
                    console.log("getCertificados() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },             
        getHistorico: function() {
            var self        = this;
            console.log("getHistorico()");
            // loading.show();
            
            if (self.formHistorico.page != 1) {
                loading.show();
            }

            return new Promise(function(resolve, reject) {
                
                var form = {
                    "params": {
                        "page":         self.formHistorico.page ? self.formHistorico.page : 1,
                        "usuarioCod":   self.form.cod
                    },
                    "authentication":   true
                };

                axios.get("api/prontuario.php", form)
                .then(response => {
                    
                    console.log("getHistorico() response", response);

                    self.registros      = response.data.result; 
                    // loading.hide();
                    self.$forceUpdate();

                    if (form.params.page) {
                        // TODO scroll top
                        if ($(".page-content")[0]) $(".page-content")[0].scrollTo({
                            top: 5
                        });                                             
                        
                    }
                    if (self.formHistorico.page != 1) loading.hide();

                    resolve(response.data.result);

                })
                .catch(error => {
                    console.log("getHistorico() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },    
        getPrescricoes: function() {
            var self        = this;
            console.log("getPrescricoes()");
            // loading.show();

            if (self.formPrescricao.page != 1) {
                loading.show();
            }

            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "page":         self.formPrescricao.page ? self.formPrescricao.page : 1,
                        "usuarioCod":   self.form.cod
                    },
                    "authentication":   true
                };

                axios.get("api/prescricoes.php", form)
                .then(response => {
                    
                    console.log("getPrescricoes() response", response);

                    self.prescricoes    = response.data.result; 
                    // loading.hide();
                    
                    self.$forceUpdate();

                    if (form.params.page) {
                        // TODO scroll top
                        $(".page-content")[0].scrollTo({
                            top: 5
                        });                                             
                        
                    }
                    if (self.formPrescricao.page != 1) loading.hide();
                    
                    resolve(response.data.result);

                })
                .catch(error => {
                    console.log("getPrescricoes() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },                           
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "cod":          self.form.cod
                    },
                    "authentication":   true
                };

                axios.get("api/pacientes-v2.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    var d               = response.data.result.dataNascimento.split("-");
                    response.data.result.dataNascimento = d[2] + "/" + d[1] + "/" + d[0];
                    self.detalhes       = response.data.result;
                    self.formEditar     = JSON.parse(JSON.stringify(response.data.result));
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        delRegistro: function(cod) {
            console.log("delRegistro()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja remover esse item?", function() {
                var form                = {};
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/prontuario.php", {params: form, authentication: true})
                .then(response => {
                    self.getHistorico().finally(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("delRegistro() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        delPrescricaoMemed: function(id) {
            console.log("delPrescricaoMemed()", id);
            var self                = this;
            var form                = {};
            form.integracaoId       = id;
            loading.show();
            
            axios.delete("api/prescricoes.php", {params: form, authentication: true})
            .then(response => {
                loading.hide();
            })
            .catch(error => {
                console.log("delPrescricaoMemed() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        }, 
        delPrescricao: function(cod) {
            console.log("delPrescricao()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja remover esse item?", function() {
                var form                = {};
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/prescricoes.php", {params: form, authentication: true})
                .then(response => {
                    self.getPrescricoes().finally(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("delPrescricao() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
        getTokenMemed: function() {
            var self        = this;
            console.log("getTokenMemed()");

            return new Promise(function(resolve, reject) {
                
                if (!self.$root.user.memedToken) {
                    resolve(true);
                    return false;
                }

                var form = {
                    "params": {
                        "tipo":         "memed-token"
                    },
                    "authentication":   true
                };

                axios.get("api/conta.php", form)
                .then(response => {
                    
                    console.log("getTokenMemed() response", response);

                    self.$root.user.memedToken = response.data.result.memedToken; 
                    self.$root.setUser(response.data.result); 
                    resolve(response.data.result);

                })
                .catch(error => {
                    console.log("getTokenMemed() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        processaMemed() {
            console.log("processaMemed()")
            return Promise.resolve()
            .then(this.getTokenMemed)
            .then(this.initMemed)            
        }
        // initAutocompletePrescricao() {
        //     var self = this;
        //     console.log("initAutocompletePrescricao()")

        //     self.autocomplete = window.___app.autocomplete.create({
        //         inputEl: '#autocomplete-dropdown',
        //         openIn: 'dropdown',
        //         requestSourceOnOpen: true,
        //         preloader: true, 
        //         valueProperty: 'nome',
        //         updateInputValueOnSelect: false,
        //         textProperty: 'nome',
        //         limit: 20,
        //         typeahead: false,
        //         autoFocus: true,
        //         multiple: true,
        //         expandInput: false,
        //         popupCloseLinkText: "Voltar",
        //         popupSwipeToClose: true,
        //         // renderItem: function(item, index) {
        //         //     console.log("renderItem()", item, index)
        //         //     return item.text;
        //         // },
        //         searchbarPlaceholder: "Pesquise um produto...",
        //         searchbarDisableText: "Cancelar",
        //         pageTitle: "Adicionar item",
        //         notFoundText: "Nenhum resultado encontrado.",
        //         dropdownPlaceholderText: 'Adicionar item..',
        //         opened: function () {
        //             console.log('Autocomplete opened')
        //         },                
        //         source: function (query, render) {
        //             console.log("autocomplete source", query)
        //             var autocomplete = this;
        //             var results = [];
        //             autocomplete.preloaderShow();



        //             var itens = [];                        
        //             var search= clean(query);


        //             // if (!search.trim()) {
        //             //     autocomplete.preloaderHide();
        //             //     render([]);
        //             //     return false;
        //             // }

        //             // self.lista.itens.forEach(function(item) {
        //             //     var compare = clean(item.nome);

        //             //     console.log("COMPARE ", compare, "=", search);

        //             //     if ((compare.indexOf(search) != -1)) {
        //             //         itens.push(item);
        //             //     }
        //             // });

        //             if (self.cancelToken) {
        //                 console.log("Possui cancelToken", self.cancelToken);
        //                 self.cancelToken.cancel();
        //                 self.cancelToken  = axios.CancelToken.source();
        //             } else {
        //                 self.cancelToken  = axios.CancelToken.source();
        //                 console.log("Cria cancelToken", self.cancelToken);
        //             }

        //             var form = {
        //                 "params": {
        //                     "_cod":         self.$root.user.cod, 
        //                     "_token":       self.$root.user.token,
        //                     "pesquisa":     search,
        //                     "autocomplete": true
        //                 },
        //                 "cancelToken":      self.cancelToken.token
        //             };

        //             axios.get("api/prescricoes.php", form)
        //             .then(response => {
                        
        //                 console.log("get() response", response);
                        
        //                 response.data.result.itens.forEach(function(item) {
        //                     var compare = clean(item.nome);
        //                     if ((compare.indexOf(search) != -1)) {
        //                         itens.push(item);
        //                     }
        //                 });

  

        //                 autocomplete.preloaderHide();
        //                 render(itens);

        //             })
        //             .catch(error => {
        //                 console.log("get() error", error);                    

        //                 autocomplete.preloaderHide();

        //                 if (error.__CANCEL__) return false;

        //                 self.$root.notification("Erro", (error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));                   
        //             }); 


        //         },
        //         on: {
        //             change: function (val) {
                            
        //                 console.log("on change>", val);

        //                 if (val[0]) {
        //                     self.formPrescricao.itens.push(val[0]);
        //                 }
        //                 self.$forceUpdate();

        //             },
        //         }                
        //     });      
        //     window._autoc = self.autocomplete;            
        // }          
    },    
    created: function() {
        var self = this;

        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        self.form.cod = self.$route.query.c;
        loading.show();

        Promise.all([
            self.$root.getUser(),
            self.getModelos(),
            self.getHistorico(),
            self.getCertificados(),
            self.get(),
            self.processaMemed()
        ])
        .then((result) => {

            if (!self.formPrescricao.pdfLogo && self.$root.user.pdfLogo) {
                self.formPrescricao.pdfLogo = self.$root.user.pdfLogo;
            }

            if (!self.formPrescricao.pdfRegistroClasse || !self.formPrescricao.pdfEspecialidade) {
                self.formPrescricao.pdfRegistroClasse   = (!self.$root.user.pdfRegistroClasse ? self.$root.user.registroClasse : self.$root.user.pdfRegistroClasse);
                self.formPrescricao.pdfEspecialidade    = (!self.$root.user.pdfEspecialidade ? self.$root.user.categoriasNomes : self.$root.user.pdfEspecialidade);
                self.$forceUpdate();
            }
    
            console.log("promise.all result", result);
            loading.hide();
        })
        .catch((error) => {
            console.error("promise.all error", error);
            loading.hide();
        });
    },
    mounted: function() {
        var self = this;


    }      
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    .v-html p {
        margin: 0px !important;
    }

    .autocomplete-dropdown-in {
        margin-top: 5px !important;
        padding-top: 0px !important;
    }

    .autocomplete-dropdown-inner ul {
        padding-left: 0px !important;
    }
    
    .autocomplete-dropdown-inner .list {
        width: 100% !important;
        max-width: 100% !important;
    }

    .autocomplete-dropdown .list {
        border-top: 1px solid #efefef;
    }

    

</style>
<style scoped="">


    .item-content table {
        width: 100%;
    }

    .item-content table td {
        border-bottom: 1px solid #ddd;
        color: #222;
    }

    .item-content table td .delete {
        font-size: 26px
    }

    #avatar-imagem {
        cursor: pointer;
    }   
    #avatar-imagem img {
        border: 1px solid #ddd;
        border-radius: 8px;
    }
    #avatar-imagem i {
        position: absolute;
        right: -5px;
        top: 1px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: block;
        text-align: center;
        line-height: 130%;
    }

    .subnavbar {
        display: block !important;
        position: static !important;        
        background: transparent !important;
    }

    .subnavbar .segmented {
        background: var(--f7-theme-color) !important;        
    }

    .subnavbar .button:not(.button-active) {
        color: #fff;
    }

    .subnavbar .button {
        font-size: 14px !important;
        height: 40px;
    }

    .timeline-item-inner {
        background: #ededed !important;
        color: #333 !important;
    }   

    .media-list .item-title {
        font-size: 18px !important;
    }

    .media-list ul {
        background: transparent !important;
    }

    .modal-prontuario {
        background: rgba(0,0,0,0.6) !important;
    }

    .modal-assinatura .tingle-modal-box {
        width: 50vw;
    }

    .tingle-modal-box {
        height: auto;
        margin-top: 50px;
        margin-bottom: 50px;
        width: 80%;
    }

    .modal-completar-dados .tingle-modal-box {
        width: 500px;
    }

    .tingle-modal:before {
        display: none !important;
    }

    .modal-prontuario p {
        font-size: 14px;
        line-height: 130%;
        color: red;
    }

    .modal-prontuario small {
        display: block;
        line-height: 120%;
        font-size: 12px;
        color: #444;
    }

    .modal-prontuario .close {
        background: var(--f7-theme-color) !important;
        font-size: 40px;
        line-height: 60px;
        text-align: center;
        height: 60px;
        width: 60px;
        color: #fff !important;
/* todo cor        */
    }

    .text-editor-content {
        border: 1px solid #ddd;
        padding: 10px;
/*        min-height: 250px;*/
    }

    .text-editor {
        min-height: 350px;
    }

    .modal-prontuario h3 {
        font-weight: bold;
/*        padding-right: 10%; */
        margin-bottom: 15px;        
    }

    .float-right {
        float: right;
    }

    .file-input {
      display: inline-block;
      text-align: left;
      background: #fff;
      padding: 16px;
      padding-left: 0px !important;
/*      width: 450px;*/
      position: relative;
      width: 100%;
      border-radius: 3px;
    }

    .file-input > [type='file'] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 10;
      cursor: pointer;
    }

    .file-input > .button {
      display: inline-block;
      cursor: pointer;
      background: #eee;
      padding: 8px 16px;
      border-radius: 2px;
      margin-right: 8px;
      height: 40px;
      margin-bottom: 10px;
    }

    .file-input:hover > .button {
      background: dodgerblue;
      color: white;
    }

    .file-input > .label {
      color: #333;
      white-space: nowrap;
      opacity: .3;
    }

    .file-input.-chosen > .label {
      opacity: 1;
    }    

    .page-content {
        padding-bottom: 50px;
        overflow-x: hidden !important;
    }

    .timeline-item-text {
        font-size: 14px;
        font-weight: 400;
        padding-left: 20px;
        padding-bottom: 10px;

/*        max-height: 150px;*/
/*        overflow: hidden;*/
    }


    .timeline-item-text b {
        font-weight: 600 !important;
    }

    .timeline-item-content {
        width: 100%;
    }

    .timeline-item-text a i {
        margin-right: 5px;
    }

    .timeline-item-title {
        margin-bottom: 10px;
    }

    hr {
        opacity: 0.5;
        margin-bottom: 15px;
        margin-top: 10px;
    }

    .col-100 h3 button {
        min-width: 300px; 
        width: auto; 
        position: relative; 
        display: inline-block; 
        float: right;
        margin-top: -5px;
    }

    .container-bg {
        background: #f9f9f9; 
        padding: 10px; 
        width: 100%;
        border-top: 1px solid #ddd;
        margin-top: -1px;        
    }

    .file-list {
        margin-top: 5px;
        margin-bottom: 0px;
/*        max-width: 300px;*/

    }

    .file-list a {
        font-size: 20px;
        float: right;
    }

    .hr {
        width: 100%;
        border-bottom: 1px solid #ddd;

    }

    @media only screen and (max-width: 575px) {


        .timeline {
            padding-left: 0px !important;
            padding-right: 0px !important;
        }


        .container {
/*            padding-left: 0px !important;*/
/*            padding-right: 0px !important;*/
        }

        .container-bg {
            padding: 0px !important;
            padding-bottom: 10px !important;
        }

        .tingle-modal-box {
            height: 100vh !important;
            width: 100% !important;
            margin-top: 0px !important;
            margin-bottom: 0px !important;
        }

        .modal-prontuario .close {
            line-height: 40px;
            height: 40px;
            width: 40px;                        
        }
    }

    @media only screen and (min-width: 576px) and (max-width: 767px) {
/*      .hidden-sm {*/
/*        display: none !important;*/
/*      }*/
    }

    @media only screen and (min-width: 768px) and (max-width: 991px) {
/*      .hidden-md {*/
/*        display: none !important;*/
/*      }*/
    }

    @media only screen and (min-width: 992px) and (max-width: 1199px) {
/*      .hidden-lg {*/
/*        display: none !important;*/
/*      }*/
    }

    @media only screen and (min-width: 1440px) {
/*      .hidden-xl {*/
/*        display: none !important;*/
/*      }*/
    }




</style>



// WEBPACK FOOTER //
// src/components/ProntuarioPacientes.vue